import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { useTranslation } from "react-i18next";
import { WalletContext } from "../Wallet/WalletProvider";

function UnsuccessfulPurchase({ theme, setCheckoutStatus }) {
  const [active, setActive] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 150);
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setCheckoutStatus();
          }, 150);
        }}
      ></div>
      <div className={`popupMainDiv noPadding ${theme} ${active && "active"}`}>
        <div className="popupContentDiv">
          <div>
            {t("Your balance is insufficient; please increase your balance.")}
          </div>

          <div
            className="linkDiv"
            onClick={() => {
              setActive(false);
              setTimeout(() => {
                navigate("/interal_accounting");
              }, 150);
            }}
          >
            {t("Open the Walet")}
            <img src="/icons/link.png"></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default UnsuccessfulPurchase;
